module.exports = __webpack_public_path__ + "img/login-bg.5a6e8bad.jpg";